<template>
<div>group</div>
</template>

<script>
export default {
  name: 'BoardGroups'
}
</script>

<style scoped>

</style>
